export default __webpack_public_path__ + "static/media/ShXAiXEa_m.e45d31ca.svg";